import { useEffect } from "react";

// Custom magnetic cursor (desktop / fine-pointer only).
export function Cursor() {
  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return;

    const dot = document.createElement("div");
    dot.className = "wf-cursor-dot";
    const ring = document.createElement("div");
    ring.className = "wf-cursor-ring";
    document.body.appendChild(dot);
    document.body.appendChild(ring);
    document.documentElement.classList.add("wf-has-cursor");

    let rx = 0, ry = 0, dx = 0, dy = 0, raf;
    const move = (e) => {
      dx = e.clientX; dy = e.clientY;
      dot.style.transform = `translate(${dx}px, ${dy}px) translate(-50%, -50%)`;
    };
    const tick = () => {
      rx += (dx - rx) * 0.18; ry += (dy - ry) * 0.18;
      ring.style.transform = `translate(${rx}px, ${ry}px) translate(-50%, -50%)`;
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);

    const over = (e) => { if (e.target.closest("a,button,[data-cursor]")) ring.classList.add("hovering"); };
    const out = (e) => { if (e.target.closest("a,button,[data-cursor]")) ring.classList.remove("hovering"); };

    window.addEventListener("mousemove", move);
    document.addEventListener("mouseover", over);
    document.addEventListener("mouseout", out);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("mousemove", move);
      document.removeEventListener("mouseover", over);
      document.removeEventListener("mouseout", out);
      dot.remove(); ring.remove();
      document.documentElement.classList.remove("wf-has-cursor");
    };
  }, []);

  return null;
}
